export const REMAINING_DAYS = {
  SIX: 6,
  TWELVE: 12,
};
